
<template>

    <div style="height: 100%; width: 100%">

        <iframe v-if="url !== null" name="game" height="100%" width="100%" style="border:0;" :src="url"></iframe>

        <Alert v-else :atype="alertType" :message="alertMessage" :visibility="visibility" />

    </div>

</template>

<script>
import Api from "@/api";
import Alert from "@/components/Reusable/Alert.vue";

export default {
    name: 'Mini-Geme',
    data() {
        return {
            url: null,
            alertType: "",
            alertMessage: "",
            visibility: false,
        }
    },
    components: {
        Alert,
    },
    mounted: async function() {

        let res = await Api.getMemberMiniGameUrl({
            access_token: this.$store.getters.user_token
        });

        if (res.success) {

            this.url = res.data;

        } else {

            this.visibility = true;

            this.alertMessage = res.message;

            this.alertType = "error";

        }

    },
}
</script>


